function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "a whole year");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.2
}, /*#__PURE__*/React.createElement("path", {
  d: "M976.46,703q-11.34,6.83-23.13,13.23c-1.22.66-2.44,1.32-3.66,2q-8.86,4.75-18,9.24.07-.72.18-1.44a43.59,43.59,0,0,1,4.58-14.22,35.82,35.82,0,0,1,3.9-6c5.95-7.43,14.21-11.58,22.65-10.37A22,22,0,0,1,976.46,703Z",
  transform: "translate(-51.21 -102.69)",
  fill: "#3f3d56"
}), /*#__PURE__*/React.createElement("path", {
  d: "M990.32,691.63c-.15,1.07-.34,2.12-.57,3.16Q983.2,699,976.46,703q-11.34,6.83-23.13,13.23c-1.22.66-2.44,1.32-3.66,2a24.36,24.36,0,0,1-4-3.69,31,31,0,0,1-5.31-8.69,43.32,43.32,0,0,1,6-41.93c6-7.43,14.21-11.58,22.65-10.37s15.2,7.52,18.82,16.32A41.79,41.79,0,0,1,990.32,691.63Z",
  transform: "translate(-51.21 -102.69)",
  fill: "#3f3d56"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 970.13,
  cy: 645.93,
  rx: 34.66,
  ry: 26.48,
  transform: "translate(141.57 1411.63) rotate(-81.82)",
  fill: "#3f3d56"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1147.49,299.34a126.31,126.31,0,0,1-19,50.84l-74.4-11.26,67.24,21.21a128.68,128.68,0,0,1-11.83,13,126.84,126.84,0,0,1-22.3,155.22,126.22,126.22,0,0,1,16.91,68.48c-31.63,36.81-70.22,69.83-114.33,98Q983.2,699,976.46,703q-11.34,6.83-23.13,13.23c-2.59-.5-5.14-1.07-7.66-1.73-3.13-.79-6.2-1.71-9.21-2.73A126.83,126.83,0,0,1,889.84,500q-1.92-3.31-3.63-6.73h0c-.34-.66-.66-1.32-1-2a126.22,126.22,0,0,1-12.2-61.9l.15-2.21c.09-1.19.2-2.39.32-3.58.18-1.68.39-3.37.63-5.06l0-.16a125.93,125.93,0,0,1,12.38-39.15l90.71,45.68-82.71-59.28a127,127,0,0,1,17.6-20.84A126.83,126.83,0,1,1,1139.66,234l-101.87,54.49,107.36-37.47A126.47,126.47,0,0,1,1147.49,299.34Z",
  transform: "translate(-51.21 -102.69)",
  fill: "#80bcb8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1104.08,596.79c-31.63,36.81-70.22,69.83-114.33,98Q983.2,699,976.46,703q-11.34,6.83-23.13,13.23c-2.59-.5-5.14-1.07-7.66-1.73-3.13-.79-6.2-1.71-9.21-2.73A126.83,126.83,0,0,1,889.84,500q-1.92-3.31-3.63-6.73h0c-.34-.66-.66-1.32-1-2a126.22,126.22,0,0,1-12.2-61.9l.15-2.21c.09-1.19.2-2.39.32-3.58.18-1.68.39-3.37.63-5.06l0-.16c.78-2.7,11.1-.43,26.82,5h0l3.32,1.18c3.48,1.25,7.19,2.63,11.09,4.14h0c8.51,3.28,17.91,7.15,27.83,11.43h0l.65.28h0l1.38.6h0c66.7,28.92,154.44,75.32,141.86,87.3A126.22,126.22,0,0,1,1104.08,596.79Z",
  transform: "translate(-51.21 -102.69)",
  opacity: 0.1
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.2
}, /*#__PURE__*/React.createElement("path", {
  d: "M370.12,759.12q-6.3-2.18-12.51-4.48-14.46-5.32-28.47-11.25a20.79,20.79,0,0,1,6.35-3.52c8.33-2.86,17.48-.13,24.93,6.45A42.3,42.3,0,0,1,370.12,759.12Z",
  transform: "translate(-51.21 -102.69)",
  fill: "#3f3d56"
}), /*#__PURE__*/React.createElement("path", {
  d: "M360.42,746.32a33.41,33.41,0,0,1-2.81,8.32q-14.46-5.32-28.47-11.25-12.19-5.13-24-10.71a45.51,45.51,0,0,1-.46-7.21,40.42,40.42,0,0,1,.8-7.48c2-9.83,7.66-17.66,16-20.52s17.48-.13,24.93,6.46a39.43,39.43,0,0,1,4.94,5.26,46.59,46.59,0,0,1,7.48,14.08A45.05,45.05,0,0,1,360.42,746.32Z",
  transform: "translate(-51.21 -102.69)",
  fill: "#3f3d56"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 318.87,
  cy: 689.76,
  rx: 27.32,
  ry: 36.55,
  transform: "translate(-244.25 25.48) rotate(-17.54)",
  fill: "#3f3d56"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 304.81,
  cy: 647.35,
  rx: 27.32,
  ry: 36.55,
  transform: "matrix(0.95, -0.3, 0.3, 0.95, -232.13, 19.27)",
  fill: "#3f3d56"
}), /*#__PURE__*/React.createElement("path", {
  d: "M351.3,709.19q-4.17,2.44-8.56,4.57a129.57,129.57,0,0,1-14.53,6,127.24,127.24,0,0,1-13.81,3.91q-4.87,1.1-9.75,1.79-6.06.87-12.09,1.14c-48.32-24-91.7-53.36-128.72-86.89-.53-1.42-1-2.85-1.51-4.3a136.3,136.3,0,0,1,.46-87.6,133.67,133.67,0,0,1-52.52-69.38,136.77,136.77,0,0,1-7-43H208L104.29,418.85a136,136,0,0,1,6.44-28,133.61,133.61,0,0,1-52.52-69.37c-23.26-70.11,13.31-146,81.68-169.54,45.77-15.74,94.18-4,128.17,26.5l-68.15,99.76,81.14-86.32a135,135,0,0,1,24.72,44.42,136.59,136.59,0,0,1,6.28,57L238.42,318l71.7-11.93a135.2,135.2,0,0,1-4.81,17.84,133.65,133.65,0,0,1,52.52,69.37,136.8,136.8,0,0,1,7,41.84v.11c0,1.1,0,2.2,0,3.3,0,.47,0,.93,0,1.4a136,136,0,0,1-7.41,41,132,132,0,0,1,27,24.05c.2.22.39.44.57.67a134.83,134.83,0,0,1,24.91,44.65C430.37,612,404.46,678.2,351.3,709.19Z",
  transform: "translate(-51.21 -102.69)",
  fill: "#80bcb8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M351.3,709.19q-4.17,2.44-8.56,4.57a129.57,129.57,0,0,1-14.53,6,127.24,127.24,0,0,1-13.81,3.91q-4.87,1.1-9.75,1.79-6.06.87-12.09,1.14c-48.32-24-91.7-53.36-128.72-86.89-.53-1.42-1-2.85-1.51-4.3a136.3,136.3,0,0,1,.46-87.6,133.67,133.67,0,0,1-52.52-69.38c-3.59-10.82,146.12-19.55,214.31-11.18l1.59.2c20.7,2.67,33.41,7,31.2,13.41a132,132,0,0,1,27,24.05c.2.22.39.44.57.67a134.83,134.83,0,0,1,24.91,44.65C430.37,612,404.46,678.2,351.3,709.19Z",
  transform: "translate(-51.21 -102.69)",
  opacity: 0.1
}));

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M433.42,334.35a4.74,4.74,0,0,0,.86-2.64c0-5.75-11.71-10.4-26.15-10.4S382,326,382,331.71a5,5,0,0,0,1.07,3c-16.07,1.79-26.9,5.16-26.9,9,0,5.74,24,10.39,53.55,10.39s53.55-4.65,53.55-10.39C463.26,339.59,451.1,336.05,433.42,334.35Z",
  transform: "translate(-51.21 -102.69)",
  fill: "#80bcb8",
  opacity: 0.1
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M848.34,123.4a7.61,7.61,0,0,0,1.37-4.21c0-9.11-18.58-16.5-41.5-16.5s-41.5,7.39-41.5,16.5a7.81,7.81,0,0,0,1.71,4.69c-25.52,2.85-42.71,8.19-42.71,14.31,0,9.11,38,16.5,85,16.5s85-7.39,85-16.5C895.71,131.7,876.4,126.09,848.34,123.4Z",
  transform: "translate(-51.21 -102.69)",
  fill: "#80bcb8",
  opacity: 0.1
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M515.34,123.4a7.61,7.61,0,0,0,1.37-4.21c0-9.11-18.58-16.5-41.5-16.5s-41.5,7.39-41.5,16.5a7.81,7.81,0,0,0,1.71,4.69c-25.52,2.85-42.71,8.19-42.71,14.31,0,9.11,38.05,16.5,85,16.5s85-7.39,85-16.5C562.71,131.7,543.4,126.09,515.34,123.4Z",
  transform: "translate(-51.21 -102.69)",
  fill: "#80bcb8",
  opacity: 0.1
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M410.13,209.54c2.34-1.35,5.48-.06,7.08,2.11s2.06,5,2.46,7.63c.89,5.91,1.53,12.7-2.45,17.16,6.51-19.77,25.26-34.92,46-37.13",
  transform: "translate(-51.21 -102.69)",
  fill: "none",
  stroke: "#80bcb8",
  strokeMiterlimit: 10,
  strokeWidth: 3,
  opacity: 0.1
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M671.6,111.52c1.5-.87,3.53,0,4.56,1.35a10.7,10.7,0,0,1,1.57,4.91c.57,3.8,1,8.16-1.57,11a35.86,35.86,0,0,1,29.55-23.87",
  transform: "translate(-51.21 -102.69)",
  fill: "none",
  stroke: "#80bcb8",
  strokeMiterlimit: 10,
  strokeWidth: 3,
  opacity: 0.1
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M843.6,296.52c1.5-.87,3.53,0,4.56,1.35a10.7,10.7,0,0,1,1.57,4.91c.57,3.8,1,8.16-1.57,11a35.86,35.86,0,0,1,29.55-23.87",
  transform: "translate(-51.21 -102.69)",
  fill: "none",
  stroke: "#80bcb8",
  strokeMiterlimit: 10,
  strokeWidth: 3,
  opacity: 0.1
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M598.39,167.68c-4.28,3.58-7.3,8.17-12,11.4-5.66,3.9-13.09,5.38-20,7.47s-14,5.37-16.78,11.06c-2.36,4.87-1,10.52-3,15.5-2.15,5.29-7.73,9-12,13.27-8.44,8.42-12.19,20-10,30.8,1.51,7.47,5.64,14.37,8.09,21.66,3,8.92,3.42,18.27,3.84,27.52.78,17.37,1.55,34.91-2.36,52-1,4.29-3.7,69.52-8.93,69.39,13.88-1.19,27.84-1.32,41.79-1.46l209-2c-9.63-12.6-15.78-87.06-17.82-101.91-3.52-25.6,5-51.23,6-77,.14-3.32.14-6.73-1.23-9.85-1.44-3.27-4.32-6.06-5.28-9.45-1.38-4.85,1.39-9.82,1.48-14.8.18-10-10-17.67-18.07-25.08-7.78-7.13-14.25-15.23-22.28-22.18s-18.12-12.84-29.6-13.91c-9.43-.87-18.8,1.58-27.83,4-10.77,2.88-21,6.52-32.43,6.34C616.37,160.23,608.6,161.28,598.39,167.68Z",
  transform: "translate(-51.21 -102.69)",
  fill: "#2f2e41"
});

var _ref12 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.1
}, /*#__PURE__*/React.createElement("path", {
  d: "M742.35,207.07a13.94,13.94,0,0,0,1.26,3.14A18.46,18.46,0,0,0,742,203.7,12,12,0,0,0,742.35,207.07Z",
  transform: "translate(-51.21 -102.69)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M539.66,367.64l-1.16.1A5.45,5.45,0,0,0,539.66,367.64Z",
  transform: "translate(-51.21 -102.69)"
}));

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M756.69,728a8.81,8.81,0,0,1-4.4,1.79c-25.57,5.25-51.37,9.73-77.44,11.15-23,1.26-46.07.13-69.08-1s-46-2.27-68.46-6.92a174.48,174.48,0,0,0,17.3-59.81,176.59,176.59,0,0,0,.69-27.5,30.75,30.75,0,0,0-.4-3.29c-1.07-6.58-3.71-16.11-1.31-20.87,3.08-6.12,14.91-6.32,20.69-7.46,9.82-1.93,19.69-3.54,29.6-4.89,39.33-5.35,79.06-6.57,118.69-7.76,5.32-.16,11.66.2,14.43,4.75,1.55,2.55,1.47,5.73,1.39,8.72q-.27,9.71.19,19.42A259.76,259.76,0,0,0,756.76,718C758.08,721.27,759.29,725.55,756.69,728Z",
  transform: "translate(-51.21 -102.69)",
  fill: "#fbbebe"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M601.09,371.89c-4.18,5.15-10.07,8.61-16,11.65a199.86,199.86,0,0,1-21.85,9.68c-1.51,2.29-.31,5.33,1,7.77,11.73,22.78,27.43,45.42,51.11,55.21,12.15,5,25.48,6.25,38.58,7.42,4.08.36,8.24.72,12.22-.26s7.68-3.35,11-5.86a102.61,102.61,0,0,0,39.72-67.73c.32-2.39.32-5.32-1.73-6.6-1.25-.77-2.84-.62-4.31-.61-9.59.1-18.09-7-22.52-15.49s-5.61-18.28-6.7-27.81c0-.21-56.38-1.4-61.47-1.44-7.94-.07-10.56.86-11.33,9C608,355.8,607,364.57,601.09,371.89Z",
  transform: "translate(-51.21 -102.69)",
  fill: "#fbbebe"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M601.09,371.89c-4.18,5.15-10.07,8.61-16,11.65a199.86,199.86,0,0,1-21.85,9.68c-1.51,2.29-.31,5.33,1,7.77,11.73,22.78,27.43,45.42,51.11,55.21,12.15,5,25.48,6.25,38.58,7.42,4.08.36,8.24.72,12.22-.26s7.68-3.35,11-5.86a102.61,102.61,0,0,0,39.72-67.73c.32-2.39.32-5.32-1.73-6.6-1.25-.77-2.84-.62-4.31-.61-9.59.1-18.09-7-22.52-15.49s-5.61-18.28-6.7-27.81c0-.21-56.38-1.4-61.47-1.44-7.94-.07-10.56.86-11.33,9C608,355.8,607,364.57,601.09,371.89Z",
  transform: "translate(-51.21 -102.69)",
  opacity: 0.1
});

var _ref16 = /*#__PURE__*/React.createElement("circle", {
  cx: 594.69,
  cy: 181.55,
  r: 77,
  fill: "#fbbebe"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M702.37,375.53c.85,10.8-115.22,20.91-119.6,7.59-2.6,3.07-7.37,3.32-11.17,2s-7-3.86-10.6-5.73c-6-3.13-12.76-4.29-19.41-5.42-10.83-1.83-23.41-3.17-31.43,4.34-2.77,2.59-4.66,6-7.44,8.6-4.86,4.52-11.73,5.93-18,8-9.05,3-17.39,7.8-25.94,12a229.85,229.85,0,0,1-63.19,20.42c-4.67.79-9.37,1.43-14,2.54-6.5,1.56-13,4.23-17.43,9.24,5.18,6.62,12.62,10.23,20.61,12.84l77.1,25.2c11.6,3.79,23.38,7.66,33.53,14.45,16.91,11.28,27.91,29.82,33.93,49.23s7.57,39.89,9.07,60.16c.65,8.81,1.24,18-2.22,26.16a202.47,202.47,0,0,0,54-.89c17.21-2.62,34.23-7.48,51.64-7.32,19,.19,37.41,6.35,56.14,9.68s39.4,3.43,55.18-7.2c-3.36-4.53-3.87-11-4-16.62l-.4-26.63a39.52,39.52,0,0,1,.64-9.6c1.34-5.7,5.11-10.48,7.52-15.81,4.65-10.29,4-22.05,4.26-33.34S763,496,770.63,487.74c5-5.39,12-8.45,19.1-10.34,12.14-3.24,24.84-3.45,37.38-4.34a334.68,334.68,0,0,0,118-30.73c-2.22-4.69-7.38-7.35-12.09-9.53-11.14-5.15-22.94-10.43-35.16-9.28-5.91.56-11.76,2.62-17.65,1.87-5.58-.72-10.52-3.88-15.94-5.39-4.11-1.14-8.41-1.31-12.63-1.95-9.74-1.49-18.88-5.5-27.89-9.47l-22.76-10c-6-2.65-12.25-5.48-16.37-10.6-1.34-1.67-2.42-3.55-3.88-5.12-2.51-2.69-6-4.28-9.49-5.39a30.74,30.74,0,0,0-13.67-1.5,80.36,80.36,0,0,0-9.35,2.45C733.19,382.48,717.67,378.26,702.37,375.53Z",
  transform: "translate(-51.21 -102.69)",
  fill: "#e83f5b"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M790.44,778.28a744.85,744.85,0,0,1-124.8,19h-.07l-105.61,0h-.06q-28.35-1.93-55.88-5.9a198.58,198.58,0,0,1,22.21-45.7,23.93,23.93,0,0,0,3.46-6.62,34.86,34.86,0,0,0,.67-6.71A32.49,32.49,0,0,1,538,713.61q3.12,1.7,6.3,3.27a201.68,201.68,0,0,0,76.94,20.65,296.28,296.28,0,0,0,42.23-.85c31.66-2.55,64.58-8.43,90.08-27.1,1.07-.78,2.13-1.59,3.18-2.42,12.39,11,19.56,27.86,24.69,43.62C784.47,760,787.29,769.2,790.44,778.28Z",
  transform: "translate(-51.21 -102.69)",
  fill: "#2f2e41"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M645.48,714.66a11.07,11.07,0,0,0,1.52,9.63,7.79,7.79,0,0,0-1.62-8.72Z",
  transform: "translate(-51.21 -102.69)",
  opacity: 0.1
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M601.73,391.4c3.88-2.12,8.07-4,12.49-4.06,6.64-.06,12.58,4,17.5,8.48A89.62,89.62,0,0,1,644,409.44c1.8,2.45,3.52,5.14,3.79,8.17s-1.39,6.44-4.35,7.16a7.67,7.67,0,0,1-5.39-1.09c-6.84-3.76-11.91-12.37-19.67-11.53-5.32.57-8.92,5.52-11.83,10-2.59,4-5.21,8.11-6.37,12.73s-.6,10,2.62,13.48c2.5,2.73,6.15,4,9.56,5.42A66.63,66.63,0,0,1,632.73,467c2.87,2.74,5.6,6,6,10s-2.63,8.4-6.59,8.12a10.55,10.55,0,0,1-4.89-2.13c-7.16-4.73-14.47-9.69-22.87-11.43-8.55-1.77-17.38,0-26,1.32Q564.2,475,549.88,475.9a23.83,23.83,0,0,1-8.47-.55c-9.44-2.92-12.19-14.93-11.09-23.61,1.17-9.28,8-11.39,15.14-16C565.54,422.6,580.44,403,601.73,391.4Z",
  transform: "translate(-51.21 -102.69)",
  fill: "#fbbebe"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M675.7,391.4c-3.89-2.12-8.07-4-12.5-4.06-6.64-.06-12.58,4-17.5,8.48a89.62,89.62,0,0,0-12.27,13.62c-1.79,2.45-3.51,5.14-3.78,8.17s1.38,6.44,4.34,7.16a7.7,7.7,0,0,0,5.4-1.09c6.84-3.76,11.91-12.37,19.66-11.53,5.33.57,8.93,5.52,11.83,10,2.59,4,5.22,8.11,6.37,12.73s.6,10-2.62,13.48c-2.49,2.73-6.15,4-9.56,5.42A66.75,66.75,0,0,0,644.69,467c-2.87,2.74-5.59,6-6,10s2.63,8.4,6.59,8.12a10.51,10.51,0,0,0,4.89-2.13c7.16-4.73,14.47-9.69,22.87-11.43,8.55-1.77,17.38,0,26,1.32,9.43,1.48,18.94,2.51,28.47,3.08a23.89,23.89,0,0,0,8.48-.55c9.43-2.92,12.18-14.93,11.09-23.61-1.18-9.28-8-11.39-15.15-16C711.89,422.6,697,403,675.7,391.4Z",
  transform: "translate(-51.21 -102.69)",
  fill: "#fbbebe"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M592.66,256.42c4.48-7.08,9.8-14.76,17.07-15.58,10.15-1.15,18.08,11.54,28.18,13.18,13,2.12,25.78-14.52,38-8.44,6,3,10.48,11.32,17,11.16,4.51-.1,8.18-4.33,11.17-8.48a158.2,158.2,0,0,0,13.35-22.12c-12.41-14.23-30.46-17.48-47.31-20.07l-28.33-4.35c-6.82-1.05-13.76-2.09-20.54-.64-6.13,1.31-11.85,4.61-17.4,8.08-6.62,4.16-22.19,10.84-26.25,18.58-2.83,5.37,1.06,7.87,4.71,13.28Q587.46,248.72,592.66,256.42Z",
  transform: "translate(-51.21 -102.69)",
  fill: "#2f2e41"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M549.75,430.22a149,149,0,0,1-37.35,2.66c-4.91-.26-9.84-.77-14.73-.31-5.9.56-11.57,2.51-17.32,3.93-29.79,7.33-60.92.17-91.33-3.85-5.37-.71-10.86-1.32-16.18-.28-4.87.95-9.37,3.23-13.68,5.68a165.25,165.25,0,0,0-20,13.39c-6.63,5.18-13.32,11.78-13.78,20.17-.4,7.22,4,13.87,9.33,18.78,14.4,13.33,35.78,17.34,55.06,13.73,7.33-1.37,14.48-3.73,21.89-4.55,7.59-.84,15.26,0,22.89-.36,15.5-.69,30.34-6.08,45.39-9.83a218.63,218.63,0,0,1,71.94-5.64,1.55,1.55,0,0,1-2.13-1.09c-1.77-4.88-1.86-10.19-1.83-15.38C548,454.68,548.59,442.76,549.75,430.22Z",
  transform: "translate(-51.21 -102.69)",
  opacity: 0.1
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M547.75,431.22a149,149,0,0,1-37.35,2.66c-4.91-.26-9.84-.77-14.73-.31-5.9.56-11.57,2.51-17.32,3.93-29.79,7.33-60.92.17-91.33-3.85-5.37-.71-10.86-1.32-16.18-.28-4.87.95-9.37,3.23-13.68,5.68a165.25,165.25,0,0,0-20,13.39c-6.63,5.18-13.32,11.78-13.78,20.17-.4,7.22,4,13.87,9.33,18.78,14.4,13.33,35.78,17.34,55.06,13.73,7.33-1.37,14.48-3.73,21.89-4.55,7.59-.84,15.26,0,22.89-.36,15.5-.69,30.34-6.08,45.39-9.83a218.63,218.63,0,0,1,71.94-5.64,1.55,1.55,0,0,1-2.13-1.09c-1.77-4.88-1.86-10.19-1.83-15.38C546,455.68,546.59,443.76,547.75,431.22Z",
  transform: "translate(-51.21 -102.69)",
  fill: "#e83f5b"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M730,424.87c15.24,3.47,51.92,5,67.54,4.48,7.13-.22,14.24-.86,21.37-.84,12.22,0,24.42,2,36.61,1.19,15.75-1.08,31.22-6.87,46.93-5.38,7.72.74,15.15,3.2,22.51,5.66s15.38,5.24,20.56,11.22c4.8,5.54,6.55,13,8.14,20.16.89,4,1.78,8.13,1,12.14-1.49,7.61-8.5,12.76-15.23,16.6-8,4.56-16.78,8.48-26,8.27-5.47-.12-10.79-1.7-16-3.34-14.93-4.69-30.19-10-45.79-8.83-10.91.84-21.81,4.86-32.54,2.69-6.31-1.28-12-4.62-18-6.84-14.62-5.35-51.73-3.93-67.23-2.45.9-8.71.79-17.49,1.69-26.21.7-6.67,1.37-13.58-.77-19.94C733.45,429.64,733,427.57,730,424.87Z",
  transform: "translate(-51.21 -102.69)",
  opacity: 0.1
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M731,426.87c15.24,3.47,51.92,5,67.54,4.48,7.13-.22,14.24-.86,21.37-.84,12.22,0,24.42,2,36.61,1.19,15.75-1.08,31.22-6.87,46.93-5.38,7.72.74,15.15,3.2,22.51,5.66s15.38,5.24,20.56,11.22c4.8,5.54,6.55,13,8.14,20.16.89,4,1.78,8.13,1,12.14-1.49,7.61-8.5,12.76-15.23,16.6-8,4.56-16.78,8.48-26,8.27-5.47-.12-10.79-1.7-16-3.34-14.93-4.69-30.19-10-45.79-8.83-10.91.84-21.81,4.86-32.54,2.69-6.31-1.28-12-4.62-18-6.84-14.62-5.35-51.73-3.93-67.23-2.45.9-8.71.79-17.49,1.69-26.21.7-6.67,1.37-13.58-.77-19.94C734.45,431.64,734,429.57,731,426.87Z",
  transform: "translate(-51.21 -102.69)",
  fill: "#e83f5b"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M572.11,274.59c-2.34-.61-3.24-3.57-5.35-4.76s-4.75-.25-6.27,1.52a10.82,10.82,0,0,0-2.18,6.5,24.58,24.58,0,0,0,15.4,23.72,100.19,100.19,0,0,1-2.4-27.78Z",
  transform: "translate(-51.21 -102.69)",
  fill: "#fbbebe"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M719.68,274.59c2.34-.61,3.23-3.57,5.34-4.76s4.75-.25,6.27,1.52a10.75,10.75,0,0,1,2.18,6.5,24.58,24.58,0,0,1-15.4,23.72,100.19,100.19,0,0,0,2.4-27.78Z",
  transform: "translate(-51.21 -102.69)",
  fill: "#fbbebe"
});

var _ref29 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.1
}, /*#__PURE__*/React.createElement("path", {
  d: "M623.83,496.34a77.76,77.76,0,0,1,2.75,21.4c0,12.57-2.47,23.54-6.15,29.43-.31,2.8-.66,5.58-1,8.31,5.19-4,9-17.14,9-32.74C628.39,512.08,626.61,502.57,623.83,496.34Z",
  transform: "translate(-51.21 -102.69)"
}));

var _ref30 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.1
}, /*#__PURE__*/React.createElement("path", {
  d: "M652,496.34a77.73,77.73,0,0,0-2.76,21.4c0,12.57,2.48,23.54,6.16,29.43.31,2.8.65,5.58,1,8.31-5.19-4-9-17.14-9-32.74C647.39,512.08,649.17,502.57,652,496.34Z",
  transform: "translate(-51.21 -102.69)"
}));

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M704,243.26c-3,4.15-6.66,8.38-11.17,8.48-6.53.16-11-8.14-17-11.16-12.17-6.08-24.92,10.56-38,8.44-10.1-1.64-18-14.33-28.18-13.18-7.27.82-12.59,8.5-17.07,15.58q-5.2-7.69-10.39-15.4c-2-3-4.17-5.15-5.14-7.37-1.94,4.76,1.7,7.28,5.14,12.37s6.92,10.27,10.39,15.4c4.48-7.08,9.8-14.76,17.07-15.58,10.15-1.15,18.08,11.54,28.18,13.18,13,2.12,25.78-14.52,38-8.44,6,3,10.48,11.32,17,11.16,4.51-.1,8.18-4.33,11.17-8.48a158.2,158.2,0,0,0,13.35-22.12c-.54-.62-1.1-1.22-1.67-1.8A159.65,159.65,0,0,1,704,243.26Z",
  transform: "translate(-51.21 -102.69)",
  opacity: 0.1
});

var SvgHeart = function SvgHeart(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b762e2c5-0937-4f80-86de-8fcef6019b76",
    "data-name": "Layer 1",
    width: 1097.59,
    height: 694.62,
    viewBox: "0 0 1097.59 694.62",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHeart, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/heart.5c22ff39.svg";
export { ForwardRef as ReactComponent };